import { createLogger } from "@/lib/logger";
import { supabase } from "@/lib/supabaseClient";

const logger = createLogger("sync-web-contact");
// v1 recorded attempts, including 401s. Only v2 represents confirmed delivery.
export const CONTACT_SYNC_SUCCESS_KEY = "chicky_loops_contact_sync_v2";
const inFlight = new Set<string>();

export async function syncWebContact(userId: string): Promise<void> {
  if (inFlight.has(userId)) return;
  inFlight.add(userId);
  try {
    try {
      const cached = JSON.parse(localStorage.getItem(CONTACT_SYNC_SUCCESS_KEY) || "null");
      const age = Date.now() - cached?.timestamp;
      if (cached?.userId === userId && age >= 0 && age < 86_400_000) return;
    } catch {
      // Corrupt/unavailable storage must not prevent an authenticated attempt.
    }
    const {
      data: { session },
      error,
    } = await supabase.auth.getSession();
    if (error || !session?.access_token || session.user.id !== userId) return;
    const response = await fetch("/api/loops/contact", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${session.access_token}`,
      },
      body: JSON.stringify({ source: "web_identify" }),
      keepalive: true,
    });
    if (!response.ok || (await response.json()).synced !== true) return;
    // A sign-out/account switch while awaiting the provider must not cache stale identity.
    const current = await supabase.auth.getSession();
    if (current.error || current.data.session?.user.id !== userId) return;
    localStorage.setItem(
      CONTACT_SYNC_SUCCESS_KEY,
      JSON.stringify({ userId, timestamp: Date.now() })
    );
  } catch {
    logger.warn("Contact sync did not complete; a later identify may retry");
  } finally {
    inFlight.delete(userId);
  }
}
